<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="primary"
          title="Protocol list"
          text=""
          class="elevation-1"
        >
          <!--v-btn
            color="pink"
            style="margin-right:10px"
            dark
            small
            absolute
            top
            right
            @click="upsertDialog()"
            v-if="$can('upsert', 'protocol')"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn-->

          <v-data-table
            id="protocol_dataTable"
            :headers="headers"
            :items="protocols"
            :loading="loading"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
            hide-actions
          >
            <v-progress-linear
              v-slot:progress
              color="primary"
              indeterminate
            ></v-progress-linear>

            <!--template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-dark text-success text-darken-3"
                v-text="header.text"
              />
            </template-->

            <template slot="headers" slot-scope="props">
              <tr>
                <th 
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ?'text-xs-' + header.align : 'text-xs-left',
                    pagination.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === pagination.sortBy &&
                    header.sortable != false ? 'active' : ''
                  ]"
                  @click="
                    if (header.sortable != false) {
                      changeSort(header.value);
                    }
                  "
                >
                  <v-icon  v-if="header.sortable != false" small>mdi-menu-down</v-icon>
                  <span 
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  />
                </th>
              </tr>
              <tr class=" lighten-3">
                <th v-for="header in props.headers" :key="header.text">
                  <div v-if="filters.hasOwnProperty(header.value)">
                   
                    <v-text-field clearable md4
                      v-if="!filters[header.value].list"
                      v-model="filters[header.value].value"
                    />

                    <v-select clearable md4
                      v-if="filters[header.value].list"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-text="filters[header.value].item_text"
                      :item-value="filters[header.value].item_value"
                      class="purple-input"
                    ></v-select>

                  </div>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
              
              <td class="text-xs-left">{{ item.id }}</td>
              <td>
                <b>
                  <!--router-link
                    style="color:black"
                    :to="{ name: 'Protocol Detail', params: { id: item.id } }"
                    >{{ item.name }}</router-link
                  -->
                    <a
                      style="color:black"
                      @click.prevent="upsertDialog(item)"
                      >{{ item.name }}</a
                    >

                </b>
              </td>
              <td class="text-xs-left">{{ item.sponsor.name }}</td>

              <td class="text-xs-right">

                <v-tooltip top>
                  <template slot="activator" slot-scope="{ on }">
                    <a flat @click="upsertDialog(item)">
                        <v-icon v-if="$can('upsert', 'protocol')" v-on="on" color="primary">mdi-pencil</v-icon>
                        <v-icon v-if="!$can('upsert', 'protocol')" v-on="on" color="primary">mdi-eye</v-icon>
                    </a>
                  </template>
                  <span>Protocol Details</span>
                </v-tooltip>
                
                &nbsp;

                <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="openAuditTrail(item)" class="ml-1">
                        <v-icon v-on="on" color="primary">mdi-timeline-clock-outline</v-icon>
                      </a>
                    </template>
                    <span>Audit Trail</span>
                </v-tooltip>

                &nbsp;&nbsp;&nbsp;
           

                
              </td>
            </template>
          </v-data-table>
        </material-card>

      </v-flex>
    </v-layout>

    <v-dialog v-model="auditTrail.open" width="1200px">
      <safety-audittrail-timeline v-if='auditTrail.open' entity="protocol" :entity_id='auditTrail.entityId' :fields="headers"/>
    </v-dialog>

  </v-container>
</template>




<script>
import { getList } from "@/api/protocol";
import { normalizeFilters } from "@/utils/filters";

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: -1,
        page: 1,
        sortBy: 'id',
        descending: true,
        totalItems:undefined
      },
      auditTrail: {
        open: false,
        entityId: null
      },
      // rowsPerPageItems: [5,10,25],
      loading: true,
      totalProtocols: 0,
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: false
        },
        {
          text: "Name",
          align: "left",
          sortable: false
        },
        { text: "Sponsor", sortable: false, align: "left"},
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ],
      filters: {
        name: {
          value: undefined,
          replace: "VALUE%"
        },
        // sponsor_id: {
        //   value: undefined,
        //   list: this.$store.getters.sponsors,
        //   item_text: 'name',
        //   item_value: 'id',
        // },
      },
      // loadedProtocols: []
    };
  },
  watch: {
    pagination: {
      handler(val, oldVal) {
        if (val.page != oldVal.page || val.rowsPerPage != oldVal.rowsPerPage ||  
          val.sortBy != oldVal.sortBy || val.descending != oldVal.descending) {
          //La prima volta non devo ricaricare
          //this.getData();
        }
      },
      deep: true
    },
    filters: {
      handler(val) {
        this.pagination.page = 1;
        // this.getData();
      },
      deep: true
    },
  },
  computed: {
    protocols: { 
      get() {
        return this.$store.getters.protocols;
      },
      set(v) {

      }
    }
  },
  created() {
    this.$store.dispatch("app/loadSponsors");
    this.$store.dispatch("app/sponsorsDisabled", false);
  },
  mounted() {
   // this.getData();

    this.$root.$on('updateProtocols', () => {
      //this.getData();
      this.$store.dispatch("app/loadProtocols");
    });

    this.$root.$on('sponsorChanged', () => {
     // this.getData();
    });

    // this.$store.watch(
    //   (state, getters) => getters.sponsor_id,
    //   (newValue, oldValue) => {
    //     console.log(`Updating from ${oldValue} to ${newValue}`);
    //     this.getData();
    //   },
    // );

    // this.$store.watch(
    //   (state, getters) => getters.protocolItem,
    //   (newValue, oldValue) => {
    //      console.log(`Updating PROTOCOL from`);
    //     this.getData();
    //   },
    // );

  },
  methods: {
    openAuditTrail (item) {
      this.auditTrail.entityId = item.id
      this.auditTrail.open = true
    },
    // getData() {
    //   this.loading = true;
    //   this.filters.sponsor_id = { value : this.$store.getters.sponsor_id};
    //   getList(normalizeFilters(this.filters), this.pagination).then(data => {
    //     this.loadedProtocols = data.data;
    //     this.pagination.rowsPerPage = data.perPage;
    //     this.pagination.page = data.currentPage;
    //     this.pagination.totalItems = data.tot;
    //     this.totalProtocols = data.tot;
    //     this.loading = false;
    //   });
    // },
    // changeSort(column) {
    //   const oldPagination = JSON.parse(JSON.stringify(this.pagination));
    //   oldPagination.page = 1;
    //   if (oldPagination.sortBy === column) {
    //     oldPagination.descending = !oldPagination.descending;
    //   } else {
    //     oldPagination.sortBy = column;
    //     oldPagination.descending = false;
    //   }
    //   this.pagination = oldPagination;
    // },
    upsertDialog(item = {}) {
      this.$store.dispatch(
        "app/openProtocolDialog",
        JSON.parse(JSON.stringify(item))
      );
    }
  }
};
</script>

<style lang="scss">
#protocol_dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
      padding: 0px 5px 0px 5px;
  }
}
</style>